import { SET_CARDS } from "../types/types";

export const setCards = (value, count) => {
  return {
    type: SET_CARDS,
    payload: { data: value },
  };
};
export const setCheckoutResponse = (value) => {
  return {
    type: "SET_CHECKOUT_RESPONSE",
    payload: { data: value },
  };
};
export const setTempPackageId = (value) => {
  return {
    type: "SET_TEMP_PACKAGE_ID",
    payload: { data: value },
  };
};
export const setMobilePaymentStatus = (value) => {
  return {
    type: "SET_MOBILE_PAYMENT_STATUS",
    payload: { data: value },
  };
};
